// platform-builder-server keeps no conversation (nothing is stored per
// request), so every call must stand alone. A follow-up message therefore
// replays the original brief plus every adjustment asked so far — newest
// last, and the newest wins — inside the same `prompt` field the first
// request used. The thread the creator sees is purely visual.

// ContentVideoScriptDTO on the server: prompt max 2000 characters.
export const PROMPT_LIMIT = 2000;

// i18next escapes interpolated values for HTML by default; this text goes
// to a model, not the DOM, so quotes and ampersands must stay literal.
const RAW = { interpolation: { escapeValue: false } };

/**
 * @param {object} input
 * @param {string[]} input.history  the creator's earlier messages, oldest first
 * @param {string}   input.text     the message being sent now
 * @param {number}   input.duration current target duration, in minutes
 * @param {function} input.t        contentModals translator
 * @param {number}  [input.limit]   server-side prompt cap
 * @returns {string} the prompt to send
 */
export function composeRequestPrompt({ history, text, duration, t, limit = PROMPT_LIMIT }) {
    if (!history.length) return text;

    const [original, ...earlier] = history;
    let adjustments = [...earlier, text];

    const build = () => [
        t("generateScript.thread.original", { text: original, ...RAW }),
        "",
        t("generateScript.thread.adjustments"),
        ...adjustments.map((item, index) => `${index + 1}. ${item}`),
        "",
        t("generateScript.thread.duration", { minutes: duration, ...RAW }),
    ].join("\n");

    // Over the cap: forget the oldest adjustments first, never the brief or
    // the message being sent.
    let output = build();
    while (output.length > limit && adjustments.length > 1) {
        adjustments = adjustments.slice(1);
        output = build();
    }

    return output.length > limit ? output.slice(0, limit) : output;
}
